import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createDataReduceObject } from '../../../../../common/reducers/data/reducer';
import getPrivateRoomSaga from './sagas/getPrivateRoomSaga';
import getMeStatSaga from './sagas/getMeStatSaga';

export default [
  ...createCombineMapItem('privateRoom', createDataReduceObject, [
    getPrivateRoomSaga
  ]),
  ...createCombineMapItem('meStat', createDataReduceObject, [getMeStatSaga])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/objects/reducersMap.js